<div id="sync-solution-panel" class="ot-panel">
  <div class="ot-row">
    <span id="system-update-wizard-text" class="ot-wizard-title ot-m-1" i18n>Install the latest System Center
      update</span>
  </div>
  <app-wizard [index]="index" [steps]="steps"></app-wizard>
  <div class="ot-wizard-panel-body">
    <ng-scrollbar #scrollbarRef>
      @if (state == SystemUpdateTaskState.DOWNLOAD) {
      <div animate.enter="enter-animation">
        @if (isOnline) {
        <div class="ot-row">
          <p id="system-update-download-step-text" class="ot-wizard-msg-text ot-pt-1" i18n>
            An update for System Center is available. This system is currently online so you can choose one of the
            following options:
          </p>
        </div>
        }
        @if (isOnline) {
        <div class="ot-row">
          <div role="list" class="ot-pl-1 ot-pb-1">
            <div role="listitem" i18n>1. Download the update from My Support by clicking the 'My Support' link in the
              table below</div>
            <div role="listitem" i18n>2. Enter your My Support credentials</div>
            <div role="listitem" i18n>3. Click next once the download is complete</div>
            <div i18n>or </div>
            <div role="listitem" i18n>1. Download the update by clicking the 'Download' icon in the table below</div>
            <div role="listitem" i18n>2. Upload the file to System Center using the 'upload' link below</div>
            <div role="listitem" i18n>3. Once the upload is complete close the dialog and click next to continue</div>
          </div>
        </div>
        }
        @if (!isOnline) {
        <div class="ot-row">
          <p id="system-update-download-step-text" class="ot-wizard-msg-text ot-pt-1" i18n>
            An update for System Center is available. This system is currently offline, please follow the instructions
            below:
          </p>
        </div>
        }
        @if (!isOnline) {
        <div class="ot-row">
          <div role="list" class="ot-pl-1 ot-pb-1">
            <div role="listitem" i18n>1. Download the update by clicking the 'Download' icon in the table below</div>
            <div role="listitem" i18n>2. Upload the file to System Center using the 'Upload the update' link below</div>
            <div role="listitem" i18n>3. Once the upload is complete close the dialog and click next to continue</div>
          </div>
        </div>
        }
        @if (isValidatingPackage && !isError) {
        <div id="system-update-download-validating" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Validating system state...
            </p>
          </div>
        </div>
        }
        @if (isDownloading && !isError) {
        <div id="system-update-download-waiting" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Please wait while the required package is downloaded...
            </p>
          </div>
        </div>
        }
        @if (!needsDownload && !isValidatingPackage && isValidatingPackageComplete && !isError && !isUpToDate) {
        <div id="system-update-download-success" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>The required package has
              been provided.</p>
          </div>
        </div>
        }
        @if ((!isDownloading && !isValidatingPackage && !isValidatingPackageComplete && !isError && !isUpToDate) ||
        (!isDownloading && needsDownload)) {
        <div id="system-update-download-warning" class="ot-message ot-message--is-warning w-100">
          <div class="ot-message__banner">
            @if (needsDownload && isOnline) {
            <span class="ot-message__item">
              <span i18n>
                Upgrading to the latest version provides the latest features, security
                updates, and bug fixes. Download from&nbsp;<a id="system-update-download-update" (click)="download()">My
                  Support</a>&nbsp;or&nbsp;<a id="system-update-upload-offline"
                  (click)="openOfflineUpload()">upload</a>&nbsp;manually.
              </span>
            </span>
            }
            @if (needsDownload && !isOnline) {
            <span class="ot-message__item">
              <span i18n>
                Upgrading to the latest version provides the latest features, security
                updates, and bug fixes. &nbsp;<a id="system-update-upload-offline-only"
                  (click)="openOfflineUpload()">Upload
                  the update</a>.
              </span>
            </span>
            }
          </div>
        </div>
        }
        @if (isError) {
        <div id="system-update-download-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
        @if (!isUpToDate) {
        <div class="ot-row">
          <app-datatable [identifier]="'system-update-packages-table'" [cols]="packageCols" [rows]="packageRows"
            [scroll]="false" [sortdata]="false" [showcheckboxes]="false"
            (actionmenuevent)="downloadActionMenuClicked($event)"></app-datatable>
        </div>
        }
      </div>
      }
      @if (state == SystemUpdateTaskState.INSTALL) {
      <div animate.enter="enter-animation">
        <div class="ot-row">
          <p id="system-update-install-step-text" class="ot-pl-1 ot-pr-1" style="font-size: 16px;" i18n>
            The update is ready to be applied. Once the update starts if this page is refreshed you might lose
            installation status
            as the system will be offline momentarily during the installation.<br><br><b>Note:</b> The manager
            and all online agents
            will be updated automatically.
          </p>
        </div>
        @if (!isInstalling && !isError) {
        <div id="system-update-install-waiting" class="ot-message ot-message--is-info w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Waiting to apply the update, click install to start...
            </p>
          </div>
        </div>
        }
        @if (isInstalling && !isError) {
        <div id="system-update-install-msg" class="ot-message ot-message--is-progress w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              {{installationProgress}}
            </p>
          </div>
        </div>
        }
        @if (isError) {
        <div id="system-update-install-error" class="ot-message ot-message--is-error w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item">
              {{errorMessage}}
            </p>
          </div>
        </div>
        }
      </div>
      }
      @if (state == SystemUpdateTaskState.COMPLETE) {
      <div animate.enter="enter-animation">
        @if (isUpToDate) {
        <div id="system-update-up-to-date" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>The system is up to date, no further action is required at this time.</p>
          </div>
        </div>
        }
        @if (isComplete) {
        <div id="system-update-complete-success" class="ot-message ot-message--is-success w-100">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              Your system has been successfully updated!
            </p>
          </div>
        </div>
        }
      </div>
      }
    </ng-scrollbar>
  </div>
  <div class="ot-wizard-panel-footer ot-wizard-panel-footer--is-right-justified">
    @if (state == SystemUpdateTaskState.DOWNLOAD) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      <button id="download-next-button" role="button" otsc-button color="primary" (click)="next()"
        [disabled]="needsDownload || !isValidatingPackageComplete || isError" i18n>Next</button>
      <button id="download-cancel-button" role="button" otsc-button color="secondary" (click)="cancel()"
        i18n>Cancel</button>
    </div>
    }
    @if (state == SystemUpdateTaskState.INSTALL) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      <button id="install-back-button" role="button" otsc-button color="secondary" [disabled]="isInstalling || isError"
        (click)="back()" i18n>Back</button>
      <button id="install-next-button" role="button" otsc-button color="primary" (click)="install()"
        [disabled]="isInstalling || isError" i18n>Install</button>
      <button id="install-cancel-button" role="button" otsc-button color="secondary" (click)="cancel()"
        [disabled]="isInstalling" i18n>Cancel</button>
    </div>
    }
    @if (state == SystemUpdateTaskState.COMPLETE) {
    <div class="ot-btn-group ot-wizard-panel-footer-btn-group">
      <button id="complete-finish-button" role="button" otsc-button color="primary" (click)="cancel()"
        i18n>Finish</button>
    </div>
    }
  </div>
</div>